


















































































import Vue from "vue";
import { mapGetters } from "vuex";
import Offline from "@/components/atoms/Offline.vue";

export default Vue.extend({
  ...{
    data() {
      return {
        selectedLocation: 0,
        isOnline: navigator.onLine,
      };
    },
    props: {
      items: Array,
      locationId: Number,
      isDisabled: Boolean,
    },
    components: {
      Offline,
    },
    mounted() {
      this.fetchLocations();
      // select prop if present
      if (this.items.length && this.locationId > 0 && !this.selectedLocation) {
        this.selectedLocation = this.locationId;
      }
      setInterval(() => {
        this.isOnline = navigator.onLine;
      }, 3000);
    },
    watch: {
      // directly load location #1 is there is just one
      items: function (newVal) {
        if (newVal.length === 1) {
          this.select(newVal[0].id);
          // redirect to Tire storage by default, if a location has tires
          if (
            this.$store.getters.showTireMenu &&
            this.$router.currentRoute.name !== "Tires"
          ) {
            window.setTimeout(() => {
              // setTimeout avoids race condition leaving select menu unhandled
              this.$router.replace({ name: "Tires" });
            }, 100);
          }
        } else if (newVal.length) {
          // @todo this is temporary to just select a location
          this.select(newVal[0].id);
        }
      },
      locationId(newVal) {
        this.selectedLocation = newVal;
      },
    },
    methods: {
      getLocation(id: number) {
        this.$store.dispatch("getLocationDetail", id);
      },
      fetchLocations() {
        if (!this.items.length) {
          this.$store.dispatch("getLocations");
        }
      },
      select(id: number): void {
        this.getLocation(id);
        this.selectedLocation = id;
      },
      formatName(str: string): string {
        return str.replace(", ", "\n");
      },
    },
    computed: {
      ...mapGetters({ locationCount: "locationCount" }),
      isMobile() {
        return this.$vuetify.breakpoint.width < 768;
      },
    },
  },
});
